import app from 'flarum/forum/app';
import Page from 'flarum/common/components/Page';
import Link from 'flarum/common/components/Link';
import Icon from 'flarum/common/components/Icon';
import CompatHistory from './CompatHistory';
import m from 'mithril';

/**
 * /compatibility/:slug — the same history as the board's modal, as a page, so
 * a game's record can be linked to directly (the wiki, a forum post).
 */
export default class CompatPage extends Page {
  product = '';
  oninit(vnode) {
    super.oninit(vnode);
    this.bodyClass = 'BnCompatPage-body';
  }
  view() {
    return m("div", {
      className: "BnCompatPage container"
    }, m(Link, {
      className: "BnCompatPage-back",
      href: app.route('index')
    }, m(Icon, {
      name: "fas fa-arrow-left"
    }), " All games"), this.product ? m("h1", {
      className: "BnCompatPage-title"
    }, this.product) : null, m(CompatHistory, {
      slug: m.route.param('slug'),
      onload: product => {
        this.product = product;
        app.setTitle(product + ' compatibility');
      }
    }));
  }
}
flarum.reg.add('blizznux-home', 'forum/components/CompatPage', CompatPage);